import * as DocumentPro from './types/DocumentPro'
import * as Document from './types/Document'
import * as Spreadsheet from './types/Spreadsheet'
import * as Presentation from './types/Presentation'
import * as Table from './types/Table'
import * as Form from './types/Form'
import { EventMap as BaseEventMap } from './types/BaseEditor'

export * from 'shimo-js-sdk-shared'

export * from './connect'

export * from './ShimoSDK'

export {
  DocumentPro,
  Document,
  Spreadsheet,
  Presentation,
  Table,
  Form,
  BaseEventMap
}

export const START_PARAMS_FIELD = 'smParams'
